import './App.css';
import Header from './components/Header/Header.jsx';
import Footer from './components/Footer/Footer.jsx';
import About from './components/About/About.jsx';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Services from './components/Services/Services.jsx';
import Home from './components/Home/Home.jsx';
import Contact from './components/Contact/Contact.jsx';
import Gallery from './components/Gallery.jsx';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* <Header /> */}
        <div className="pb-auto flex-wrap main-content">
          <Routes>
            <Route path='/' element={<Home />}/>
            <Route path='about' element={<About />}/>
            <Route path='services' element={<Services />}/>
            <Route path='contact' element={<Contact />}/>
            <Route path='gallery' element={<Gallery />}/>
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
